export function NetworkEntryCreator(url, { method, body, headers }, response) {
  const entry = {
    request: {
      url: anonymizeUrl(url),
      method,
      body: body ? JSON.parse(body) : body,
      headers
      //headers: anonymizeObject(headers)
    },
    response: {
      status: response ? response.status : '',
      headers: response ? [...response.headers] : []
    }
  };

  this.addResponseBody = tBody => {
    entry.response.body = tBody;
    return this;
  };

  this.create = () => {
    window.__DKVGLOBAL.NETWORK_TRAFFIC = extendArrayToMax10Entries(
      window.__DKVGLOBAL.NETWORK_TRAFFIC
        ? window.__DKVGLOBAL.NETWORK_TRAFFIC
        : [],
      entry
    );
  };
}

const anonymizeUrl = url =>
  url
    .replace(/medicards\/\d+/, 'medicards/:medicardNumber')
    .replace(/medicardNumber=\d+/, 'medicardNumber=:medicardNumber')
    .replace(
      /hospitalAdmissionNumber=\d+/,
      'hospitalAdmissionNumber=:hospitalAdmissionNumber'
    )
    .replace(/admissions\/\d+/, 'admissionNumber/:admissionNumber')
    .replace(/documentTemplateId=.+/, 'documentTemplateId=:documentTemplateIds')
    .replace(/hospitals\/\d+/, 'hospitals/:hospitalId');

const extendArrayToMax10Entries = (array, entry) =>
  [entry, ...array].slice(0, 10);
